import React from 'react'
import { Separator } from '@fs/zion-ui'
import AddNoteButton from '../../components/collaborate/AddNoteButton'
import { NotesLoading } from './NotesLoading'

export default function NotesCardLoading(): JSX.Element {
  return (
    <>
      {/* eslint-disable-next-line test-selectors/button -- NA */}
      <AddNoteButton disabled />
      <Separator size="nano" />
      <NotesLoading />
    </>
  )
}
